import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {LeadaComponentsModule} from 'shared/components';
import {DaytimeModule} from 'shared/daytime';

import {TipRepository} from './repositories/tip.repository';
import {TipService} from './services/tip.service';

import {ButtonListPage} from './components/button-list-page/button-list-page';
import {EnergylevelPage} from './components/energylevel-page/energylevel-page';
import {EnergylevelSliderComponent} from './components/energylevel-slider/energylevel-slider.component';
import {MessagePage} from './components/message-page/message-page';
import {MultiSliderPage} from './components/multi-slider-page/multi-slider-page';
import {PerformancelevelPage} from './components/performancelevel-page/performancelevel-page';
import {PerformancelevelSliderComponent} from './components/performancelevel-slider/performancelevel-slider.component';
import {RatingPage} from './components/rating-page/rating-page';
import {SliderPage} from './components/slider-page/slider-page';
import {TipPage} from './components/tip-page/tip-page';
import {YesNoPage} from './components/yes-no-page/yes-no-page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    DaytimeModule,
    LeadaComponentsModule,
    RouterModule.forChild([
      { path: ':id', component: TipPage },
    ]),
  ],
  providers: [
    TipRepository,
    TipService,
  ],
  declarations: [
    EnergylevelPage,
    EnergylevelSliderComponent,
    ButtonListPage,
    MessagePage,
    YesNoPage,
    RatingPage,
    TipPage,
    SliderPage,
    MultiSliderPage,
    PerformancelevelPage,
    PerformancelevelSliderComponent,
  ],
  // entryComponents: [
  //   TipPage,
  // ],
})
export class TipsModule { }
